import { Constants } from "../../utils";

const agGridDateFormatter = (dateStr: string, format = "MM-dd-yyyy") => {
    if (!dateStr) {
        return "";
    }

    const preFormattedDate = (dateStr || Constants.emptyString).trim().toUpperCase().replace(" ", "T").replace("/", "-");
    const fullLongDateParts = preFormattedDate.split(".");
    const fullDateParts = fullLongDateParts[Constants.startIndex].split("T");
    const [yearPart, monthPart, dayPart] = fullDateParts[Constants.startIndex].split("-").map(Number);
    const [hourPart, minutePart, secondPart] = fullDateParts.length > 1 ? fullDateParts[Constants.secondIndex].split(":").map(Number) : [0, 0, 0];
    const millisecondPart =
        fullLongDateParts.length > 1 && !!Number(fullLongDateParts[Constants.secondIndex]) ? Number(fullLongDateParts[Constants.secondIndex]) : Constants.zero;

    const date = new Date(yearPart, monthPart - 1, dayPart, hourPart, minutePart, secondPart, millisecondPart); // month is 0-indexed in JavaScript, so 11 is December ans 0 is January

    // Extract month, day, and year values
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
    const year = String(date.getFullYear());
    const millisecond = String(date.getUTCMilliseconds());
    const hour = String(date.getUTCHours());
    const minute = String(date.getUTCMinutes());
    const second = String(date.getUTCSeconds());

    // Replace placeholders with actual date values
    const result = format
        .replace("MM", month)
        .replace("dd", day)
        .replace("yyyy", year)
        .replace("mmm", millisecond)
        .replace("HH", hour)
        .replace("mm", minute)
        .replace("second", second);

    return result;
};

export default agGridDateFormatter;
